import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import welead1 from './pictures/welead1.jpeg';
import welead2 from './pictures/welead2.jpeg';
import welead3 from './pictures/welead3.jpeg';
import welead4 from './pictures/welead4.jpeg';
import welead5 from './pictures/welead5.jpeg';
import welead6 from './pictures/welead6.jpeg';


const Trailblazer = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC x WeLEAD: Women Trailblazers in Tech Event</h2>
                    <p class="site-post-meta">April 10, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    On April 10th, WiC, in collaboration with WeLEAD, cseed BuildHER, and WINFO hosted a Women Trailblazers in Tech Event. Attendees had a great time hearing from super inspirational female leaders, learning about their experiences across technology, and participating in a Q&A session!
                    </p>
                    <img src={welead1} alt="pic1 "/>
                    <img src={welead2} alt="pic2 "/>
                    <img src={welead3} alt="pic3 "/>
                    <img src={welead4} alt="pic4 "/>
                    <img src={welead5} alt="pic5 "/>
                    <img src={welead6} alt="pic6 "/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Trailblazer;
